import React, { FC, useEffect, useRef, useState } from "react";
import { FieldArray, Formik } from "formik";
import { Form } from "react-bootstrap";
import * as _ from "lodash";
import addBtn from "../../assets/images/plus-circle.png";
import "./dynamic-form.scss";
import closeButton from "../../assets/images/close-button.png";
import { renderControlGroup } from "./controlRender";

export interface Control {
  name: string;
  label?: string;
  placeholder?: string;
  type:
    | string
    | "text"
    | "textarea"
    | "number"
    | "checkbox"
    | "date"
    | "datetime"
    | "switch"
    | "email"
    | "select"
    | "typeahead"
    | "password"
    | "time"
    | "tel";
  required?: boolean;
  readOnly?: boolean;
  disabled?: boolean;
  options?: { value: any; label: any }[];
  onChange?: (selectedValue: any) => void;
  onInputChange?: (selectedValue: any) => void;
  maxDate?: string;
  isLoading?: boolean;
  hideVisibility?: boolean;
  selectOptions?: string[];
  selectType?: string | "single" | "multiple";
  levelInfo?: [];
  prefix?: string;
  pattern?: string;
  maxLength?: number;
}

export interface FieldArrayConfig {
  fieldArrayName: string;
}

export interface FieldArrayControls {
  controlGroup: Control[];
}

export interface FieldArray {
  fieldArrayConfig: FieldArrayConfig;
  fieldArrayControls: FieldArrayControls[];
}

export interface ControlGroup {
  controlGroup: Control[];
}

interface Control2 {
  controlGroup?: Control[];
  fieldArray?: FieldArray;
}

export interface DynamicFormConfig {
  controls: Control2[];
}

export interface DynamicFormComponentProps {
  formRef: any;
  formConfig: DynamicFormConfig;
  initialValues: any;
  actionConfig?: any;
  resetButton?: any;
  validation?: any;
  filterFormMutationFunction?: any;
  filterUpdateCount?: any;
  isSecurityMonitoring?: any;
  formGroupIndex?: any;
  onClickAddBtn?: any;
  onClickCloseBtn?: any;
  formStyle?: any;
  addButtonTitle?: string;
  onClickCloseFromStart?: boolean;
}

const DynamicFormComponent: FC<DynamicFormComponentProps> = ({
  formRef,
  formConfig,
  initialValues,
  actionConfig,
  resetButton,
  validation,
  filterUpdateCount,
  isSecurityMonitoring,
  formGroupIndex,
  onClickAddBtn,
  onClickCloseBtn,
  formStyle,
  addButtonTitle,
  onClickCloseFromStart,
  filterFormMutationFunction,
}) => {
  const [selections, setSelections] = useState<any>([]);
  const typeaheadRef = useRef<any>(null);
  const [controls, setControls] = useState(formConfig.controls);
  const [render, setRender] = useState(0);
  const [isAddingField, setIsAddingField] = useState(false);

  useEffect(() => {
    setControls(_.cloneDeep(formConfig.controls));
  }, [formConfig]);

  useEffect(() => {
    setRender(render + 1);
  }, [controls]);

  return (
    <div
      className="filter-form flex flex-col items-end mb-3"
      style={formStyle ?? {}}
    >
      <div className="w-100">
        <Formik
          key={render}
          innerRef={formRef}
          enableReinitialize={true}
          onSubmit={() => {}}
          validationSchema={isAddingField ? undefined : validation}
          initialValues={initialValues}
        >
          {({
            handleSubmit,
            handleChange,
            setFieldValue,
            values,
            touched,
            errors,
          }) => (
            <Form noValidate onSubmit={handleSubmit}>
              <div className={isSecurityMonitoring ? "" : "filter-grid"}>
                {controls?.map((c: any, i: any) => (
                  <div key={i + 0}>
                    {c.controlGroup && (
                      <div
                        key={i + 0}
                        className={`flex flex-column  w-100 ${
                          isSecurityMonitoring ? "gap-3 mb-5" : ""
                        }`}
                      >
                        {c.controlGroup.map((control: any, idx: any) => (
                          <React.Fragment key={control.name || idx}>
                            {renderControlGroup(
                              control,
                              control.name,
                              values[control?.name],
                              isSecurityMonitoring,
                              handleChange,
                              touched,
                              errors,
                              setSelections,
                              setFieldValue,
                              typeaheadRef,
                              selections,
                            )}
                          </React.Fragment>
                        ))}
                      </div>
                    )}

                    {c.fieldArray && (
                      <FieldArray
                        name={"motionTime"}
                        render={(arrayHelpers) => (
                          <div className="flex flex-col items-end">
                            {c.fieldArray.fieldArrayControls.map(
                              (fieldArray: any, i: any) => (
                                <React.Fragment key={i + 0}>
                                  {(onClickCloseFromStart || i > 0) &&
                                    onClickCloseBtn && (
                                      <div
                                        key="close"
                                        className=" position-relative  "
                                      >
                                        <button
                                          type="button"
                                          style={{
                                            width: "20px",
                                            height: "20px",
                                            background: "none",
                                            border: "none",
                                            padding: 0,
                                            display: "flex",
                                          }}
                                          onClick={() => {
                                            if (onClickCloseBtn) {
                                              onClickCloseBtn.func(
                                                i,
                                                c?.fieldArray?.fieldArrayConfig
                                                  ?.fieldArrayName,
                                                onClickCloseBtn?.index,
                                              );
                                            }
                                          }}
                                          title="Remove"
                                          className="cursor-pointer"
                                        >
                                          <img
                                            className="w-100 h-100"
                                            src={closeButton}
                                            alt="close Button"
                                          />
                                        </button>
                                      </div>
                                    )}

                                  <div
                                    key={`wrapper-${i + 0}`}
                                    className={`flex w-100 ${
                                      isSecurityMonitoring ? "gap-2 mb-4" : ""
                                    }`}
                                  >
                                    {fieldArray.controlGroup.map(
                                      (control: any, idx: any) => (
                                        <React.Fragment
                                          key={control.name || idx}
                                        >
                                          {renderControlGroup(
                                            control,
                                            `${c.fieldArray.fieldArrayConfig.fieldArrayName}.${i}.${control.name}`,
                                            values[
                                              c.fieldArray.fieldArrayConfig
                                                .fieldArrayName
                                            ][i][control.name],
                                            isSecurityMonitoring,
                                            handleChange,
                                            touched,
                                            errors,
                                            setSelections,
                                            setFieldValue,
                                            typeaheadRef,
                                            selections,
                                          )}
                                        </React.Fragment>
                                      ),
                                    )}
                                  </div>
                                </React.Fragment>
                              ),
                            )}

                            {onClickAddBtn &&
                              (addButtonTitle ? (
                                <div className="d-flex w-100 mb-3">
                                  {/* <B2Button
                                      className="icon-text-btn"
                                      variant="outline-secondary"
                                      onClick={() => {
                                        if (onClickAddBtn) {
                                          onClickAddBtn.func(
                                            c?.fieldArray?.fieldArrayConfig
                                              ?.fieldArrayName,
                                            onClickAddBtn?.index
                                          );

                                          //   onClickAddBtn(
                                          //     c?.fieldArray?.fieldArrayConfig
                                          //       ?.fieldArrayName
                                          //   );
                                        }
                                      }}
                                    >
                                      <img
                                        src={addBtn}
                                        alt="Add motion time"
                                        style={{
                                          color: "#1976d2",
                                          cursor: "pointer",
                                          height: "1.5rem",
                                          width: "1.5rem",
                                        }}
                                      />
                                      <span
                                        className="ms-2"
                                        style={{ fontSize: "1rem" }}
                                      >
                                        {addButtonTitle}
                                      </span>
                                    </B2Button> */}
                                  <button
                                    onClick={() => {
                                      if (onClickAddBtn) {
                                        setIsAddingField(true);
                                        onClickAddBtn.func(
                                          c?.fieldArray?.fieldArrayConfig
                                            ?.fieldArrayName,
                                          onClickAddBtn?.index,
                                        );
                                        // Reset after reinitialization completes
                                        setTimeout(() => {
                                          setIsAddingField(false);
                                        }, 0);
                                      }
                                    }}
                                    className="d-flex align-items-center btn"
                                    style={{
                                      border: "1px solid #dee2e6",
                                      backgroundColor: "transparent",
                                      borderRadius: ".375rem",
                                      padding: ".37rem .75rem",
                                    }}
                                    title="Add"
                                  >
                                    <img
                                      src={addBtn}
                                      alt="Add motion time"
                                      style={{
                                        cursor: "pointer",
                                        height: "1.5rem",
                                        width: "1.5rem",
                                      }}
                                    />
                                    <span
                                      className="ms-2"
                                      style={{ fontSize: "1rem" }}
                                    >
                                      {addButtonTitle}
                                    </span>
                                  </button>
                                </div>
                              ) : (
                                <div className="d-flex w-100 mb-3">
                                  <button
                                    type="button"
                                    onClick={() => {
                                      if (onClickAddBtn) {
                                        setIsAddingField(true);
                                        onClickAddBtn.func(
                                          c?.fieldArray?.fieldArrayConfig
                                            ?.fieldArrayName,
                                          onClickAddBtn?.index,
                                        );
                                        // Reset after reinitialization completes
                                        setTimeout(() => {
                                          setIsAddingField(false);
                                        }, 0);
                                      }
                                    }}
                                    style={{
                                      cursor: "pointer",
                                      height: "1.5rem",
                                      width: "1.5rem",
                                      background: "none",
                                      border: "none",
                                      padding: 0,
                                      display: "flex",
                                    }}
                                    title="Add"
                                  >
                                    <img
                                      className="w-100 h-100"
                                      src={addBtn}
                                      alt="Add motion time"
                                    />
                                  </button>
                                </div>
                              ))}
                          </div>
                        )}
                      />
                    )}
                  </div>
                ))}
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default DynamicFormComponent;
